export const ADD_STORE = 'ADD_STORE';
export const ADD_STORE_SUCCESS = 'ADD_STORE_SUCCESS';
export const ADD_STORE_FAILED = 'ADD_STORE_FAILED';

export const GET_STORE = 'GET_STORE';
export const GET_STORE_SUCCESS = 'GET_STORE_SUCCESS';
export const GET_STORE_FAILED = 'GET_STORE_FAILED';

export const GET_STORE_BY_ITEMS = 'GET_STORE_BY_ITEMS';
export const GET_STORE_BY_ITEMS_SUCCESS = 'GET_STORE_BY_ITEMS_SUCCESS';
export const GET_STORE_BY_ITEMS_FAILED = 'GET_STORE_BY_ITEMS_FAILED';

export const GET_STORE_BY_ID = 'GET_STORE_BY_ID';
export const GET_STORE_BY_ID_SUCCESS = 'GET_STORE_BY_ID_SUCCESS';
export const GET_STORE_BY_ID_FAILED = 'GET_STORE_BY_ID_FAILED';

export const EDIT_STORE = 'EDIT_STORE';
export const EDIT_STORE_SUCCESS = 'EDIT_STORE_SUCCESS';
export const EDIT_STORE_FAILED = 'EDIT_STORE_FAILED';

export const DELETE_STORE = 'DELETE_STORE';
export const DELETE_STORE_SUCCESS = 'DELETE_STORE_SUCCESS';
export const DELETE_STORE_FAILED = 'DELETE_STORE_FAILED';

export const GET_STORE_BY_ITEM = 'GET_STORE_BY_ITEM';
export const GET_STORE_BY_ITEM_SUCCESS = 'GET_STORE_BY_ITEM_SUCCESS';
export const GET_STORE_BY_ITEM_FAILED = 'GET_STORE_BY_ITEM_FAILED';

export const GET_ALL_STORE_ITEMS_BY_STORES_ID= 'GET_ALL_STORE_ITEMS_BY_STORES_ID';
export const GET_ALL_STORE_ITEMS_BY_STORES_ID_SUCCESS = 'GET_ALL_STORE_ITEMS_BY_STORES_ID_SUCCESS';
export const GET_ALL_STORE_ITEMS_BY_STORES_ID_FAILED = 'GET_ALL_STORE_ITEMS_BY_STORES_ID_FAILED';

export const GET_ALL_STORES_WITH_ITEMS= 'GET_ALL_STORES_WITH_ITEMS';
export const GET_ALL_STORES_WITH_ITEMS_SUCCESS = 'GET_ALL_STORES_WITH_ITEMS_SUCCESS';
export const GET_ALL_STORES_WITH_ITEMS_FAILED = 'GET_ALL_STORES_WITH_ITEMS_FAILED';

export const GET_ALL_STOCKS_VALUES = 'GET_ALL_STOCKS_VALUES';
export const GET_ALL_STOCKS_VALUES_SUCCESS = 'GET_ALL_STOCKS_VALUES_SUCCESS';
export const GET_ALL_STOCKS_VALUES_FAILED = 'GET_ALL_STOCKS_VALUES_FAILED';

export const GET_FIFO_PRICE = 'GET_FIFO_PRICE';
export const GET_FIFO_PRICE_SUCCESS = 'GET_FIFO_PRICE_SUCCESS';
export const GET_FIFO_PRICE_FAILED = 'GET_FIFO_PRICE_FAILED';

export const SET_DEFAULT_STORE = 'SET_DEFAULT_STORE';
export const SET_DEFAULT_STORE_SUCCESS = 'SET_DEFAULT_STORE_SUCCESS';
export const SET_DEFAULT_STORE_FAILED = 'SET_DEFAULT_STORE_FAILED';